<template lang="pug">
  v-app(:style="cssProps")
    v-main
      .messages
        v-snackbar.elevation-0(top tile flat :timeout="snackbarProp.timeout" :color="snackbarProp.color" v-model="snackbarProp.show" :multi-line="snackbarProp.text2 != ''")
          .s1.basic100--text {{ snackbarProp.text }}
          .p1.basic100--text(v-if="snackbarProp.text2") {{ snackbarProp.text2 }}
        upgrade-package(v-if="upgradeDialog" :open.sync="upgradeDialog")
        upgrade-free(v-if="upgradeFree" :open.sync="upgradeFree")
        walk-through-setup(v-if="showWalkThroughDialog" :open.sync="showWalkThroughDialog")
        walk-through-setup-landing-page(v-if="showWalkThroughLandingPageDialog" :open.sync="showWalkThroughLandingPageDialog")
        walk-through-setup-books(v-if="showWalkThroughBooksDialog" :open.sync="showWalkThroughBooksDialog")
        walk-through-setup-donation(v-if="showWalkThroughDonationDialog" :open.sync="showWalkThroughDonationDialog")
        v-tour(name="YezzaTour" :steps="tourSteps")
          template(slot-scope='tour')
            transition(name='fade')
              v-step.basic1100(v-if='tour.steps[tour.currentStep]' :key='tour.currentStep' :step='tour.steps[tour.currentStep]' :previous-step='tour.previousStep' :next-step='tour.nextStep' :stop='tour.stop' :skip='tour.skip' :is-first='tour.isFirst' :is-last='tour.isLast' :labels='tour.labels')
                div.ma-n2(slot='content')
                  component(:is="tourSteps[tour.currentStep].name" :tour="tour")
                template
                  div(slot='actions')
      router-view
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import Fingerprint2 from 'fingerprintjs2'
import UpgradePackage from '@/views/admin/billing/UpgradePackage.vue'
import UpgradeFree from '@/views/admin/billing/UpgradeFree.vue'
import WalkThroughSetup from '@/views/admin/billing/WalkThroughSetup.vue'
import WalkThroughSetupLandingPage from '@/views/admin/billing/WalkThroughSetupLandingPage.vue'
import WalkThroughSetupBooks from '@/views/admin/billing/WalkThroughSetupBooks.vue'
import WalkThroughSetupDonation from '@/views/admin/billing/WalkThroughSetupDonation.vue'
import { setupLanguage } from '@/utils'

export default {
  name: 'App',
  components: { UpgradePackage, WalkThroughSetup, WalkThroughSetupLandingPage, WalkThroughSetupBooks, UpgradeFree, WalkThroughSetupDonation },
  data: () => ({
    upgradeDialog: false,
    upgradeFree: false,
    showWalkThroughDialog: false,
    showWalkThroughLandingPageDialog: false,
    showWalkThroughBooksDialog: false,
    showWalkThroughDonationDialog: false,
    snackbarProp: {
      show: false,
      color: 'success',
      text: '',
      text2: '',
      timeout: 3000
    }
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      message: 'getMessage',
      tourSteps: 'tours/getSteps',
      currency: 'getCompanyCurrency',
      lang: 'language/getLanguage'
    }),
    cssProps () {
      const themeColors = {}
      Object.keys(this.$vuetify.theme.themes[this.$theme]).forEach((color) => {
        themeColors[`--v-${color}`] = this.$vuetify.theme.themes[this.$theme][color]
      })
      return themeColors
    }
  },
  watch: {
    message (val) {
      if (val.type === 'success') {
        this.showSnackbarSuccess(val)
      } else if (val.type === 'error') {
        this.showSnackbarError(val)
      } else if (val.type === 'info') {
        this.showSnackbarInfo(val)
      } else if (val.type === 'warning') {
        this.showSnackbarWarning(val)
      } else if (val.type === 'upgrade') {
        this.upgradeDialog = true
       } else if (val.type === 'free2paid') {
        this.upgradeFree = true
      } else if (val.type === 'walk_through') {
        this.showWalkThroughDialog = true
      } else if (val.type === 'walk_through_landing_page') {
        this.showWalkThroughLandingPageDialog = true
      }  else if (val.type === 'walk_through_books') {
        this.showWalkThroughBooksDialog = true
      } else if (val.type === 'walk_through_donation') {
        this.showWalkThroughDonationDialog = true
      }
    },
    lang (val) {
      this.$root.$i18n.locale = val
    }
  },
  mounted () {
    Vue.prototype.$currency = this.currency

    // Language
    setupLanguage()
    this.$store.commit('language/recoverLanguage')

    // User
    let user = null
    let cookieUser = Cookies.get('user')
    if (cookieUser) {
      user = JSON.parse(cookieUser)
    }
    this.$store.commit('user/setUser', user)

    let device = null
    let cookieDevice = Cookies.get('yz_device')
    if (cookieDevice) {
      device = JSON.parse(cookieDevice)
      Vue.prototype.$isMobile = true
      this.disablePageZoom()
      this.syncUserWithDevice(user, device)
    } else {
      Vue.prototype.$isMobile = false
    }
    this.$store.commit('mobileapp/setDevice', device)

    // Affiliate
    const afId = this.$route.query.af_id
    if (afId) {
      const currentAfId = Cookies.get('af_id')
      if (currentAfId != afId) {
        Cookies.set('af_id', afId, { expires: 30 })
      }
      let query = {...this.$route.query}
      delete query.af_id
      this.$router.replace({ query })
    }
    const afIdCookie = Cookies.get('af_id')
    this.$store.commit('ui/setAffiliateId', afIdCookie)

    // Reminder
    let reminder = null
    let storageReminder = localStorage.getItem('reminder')
    if (storageReminder) {
      reminder = JSON.parse(storageReminder)
    }
    this.$store.commit('reminder/setReminder', reminder)
    this.$store.commit('ui/setLastIncomeTabPosition', localStorage.getItem('yz_last_income_tab_position') | 0)

    this.storeDeviceId()
    this.updateOpenTracker()

    // Global function for in-app browser navigation used in mobile app
    window.pushURL = path => {
      this.$router.push(path)
    }

    this.loadColors()
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    showSnackbarError (val) {
      this.snackbarProp.text = val.text
      this.snackbarProp.text2 = val.text2
      this.snackbarProp.color = 'danger'
      this.snackbarProp.show = true
    },
    showSnackbarSuccess (val) {
      this.snackbarProp.text = val.text
      this.snackbarProp.text2 = val.text2
      this.snackbarProp.color = 'success'
      this.snackbarProp.show = true
    },
    showSnackbarInfo (val) {
      this.snackbarProp.text = val.text
      this.snackbarProp.text2 = val.text2
      this.snackbarProp.color = 'info'
      this.snackbarProp.show = true
    },
    showSnackbarWarning (val) {
      this.snackbarProp.text = val.text
      this.snackbarProp.text2 = val.text2
      this.snackbarProp.color = 'warning'
      this.snackbarProp.show = true
    },
    storeDeviceId () {
      let handleCallback = (components) => {
        var values = components.map(function (component) { return component.value })
        var murmur = Fingerprint2.x64hash128(values.join(''), 31)
        this.$store.commit('user/setDeviceId', murmur)

        // Analytics
        if (this.user) {
          this.$logEvent('user_session.started')
        }
      }
      if (window.requestIdleCallback) {
        requestIdleCallback(function () {
          Fingerprint2.get(function (components) {
            handleCallback(components)
          })
        })
      } else {
        setTimeout(function () {
          Fingerprint2.get(function (components) {
            handleCallback(components)
          })
        }, 500)
      }
    },
    syncUserWithDevice (user, device) {
      const data = {
        uuid: device.uuid
      }
      if (user) {
        data.user = user.id
        data.logged_in = true
      } else {
        data.logged_in = false
      }
      this.$axios.post('/notifications/update_device/', data).catch(() => {})
    },
    disablePageZoom () {
      const tag = document.createElement('meta')
      tag.setAttribute('name','viewport')
      tag.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
      document.head.appendChild(tag)
    },
    updateOpenTracker () {
      setTimeout( () => {
        if (this.$route.query.t) {
          this.$axios.get(`/t/${this.$route.query.t}/`)
        }
      }, 1000)
    },
    loadColors() {
      Vue.prototype.$colors = this.$vuetify.theme.themes.light
    }
  }
}
</script>

<style lang="scss">
.v-snack__wrapper {
  max-width: 600px !important;
  width: 100% !important;
  text-align: center !important;

}
.v-snack__content {
  display: block !important;
}

.prevent-text-selection {
  -webkit-user-select: none;
  -moz-user-select: -moz-none;
  -ms-user-select: none;
  user-select: none;
}

.clickable {
  cursor: pointer;
}

.text-wrapper {
  word-break: break-word;
}
</style>
